import { CONFIGURENAME } from './../utils';
import topTitle from '@/components/title';
import { titleTop, navigation, mainDrawing, product, clause, guarantee, claims, information, bottomButton, informationConfirmation, trial, inform, disclosureIcp, productList, queryInfo, policyCancel, policyDetail, invoiceList, invoice, invoiceRecordList, invoiceDetail } from './components';
export default {
  components: {
    topTitle,
    titleTop,
    navigation,
    mainDrawing,
    product,
    clause,
    guarantee,
    claims,
    information,
    bottomButton,
    informationConfirmation,
    trial,
    inform,
    disclosureIcp,
    productList,
    queryInfo,
    policyCancel,
    policyDetail,
    invoiceList,
    invoice,
    invoiceRecordList,
    invoiceDetail
  },
  props: {
    configureObj: {
      type: Object,
      default() {
        return {};
      }
    },
    itemIndex: {
      type: Number,
      default: -1
    },
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    themeColor: {
      type: String,
      default: ''
    },
    changeType: {
      type: Boolean,
      default: false
    },
    chooseStyleArr: {
      type: Array,
      default() {
        return [];
      }
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  watch: {
    changeType: {
      handler(newObj) {
        this.timer1 = new Date().getTime();
      },
      deep: true
    }
  },
  data() {
    return {
      CONFIGURENAME,
      timer1: ''
    };
  },
  created() {},
  methods: {
    itemChange(val, showPage = false) {
      this.$emit('itemChange', val, showPage);
    },
    pageTitleChange(val) {
      this.$emit('pageTitleChange', val);
    }
  }
};